import type { LoginCredentials } from "../types/Auth";
import type { ImpersonationState, User } from "../types/User";
import { clearAuthStorage } from "../auth/authStorage";
import api from "./axiosClient";

interface AuthResponse {
    _id: string;
    name: string;
    email: string;
    role: string;
    token: string;
    tenantId?: string;
    tenant?: User["tenant"];
    impersonation?: ImpersonationState | null;
    todoAccessScopeEmails?: string[];
}

interface ImpersonationResponse {
    user: User;
    token: string;
    impersonation?: {
        byUserId: string;
        byIsSuperAdmin?: boolean;
        originalUserId?: string;
        targetUserId: string;
        targetTenantId: string;
        startedAt: string;
    } | null;
}

const authService = {
    async login(credentials: LoginCredentials): Promise<AuthResponse> {
        return (await api.post(`/users/login`, credentials)).data;
    },

    async getCurrentUser(): Promise<User> {
        return (await api.get(`/users/me`)).data;
    },

    async startImpersonation(userId: string): Promise<ImpersonationResponse> {
        return (await api.post(`/users/impersonate`, { userId })).data;
    },

    async stopImpersonation(): Promise<ImpersonationResponse> {
        return (await api.post(`/users/impersonate/stop`)).data;
    },

    logout(): void {
        api.post(`/users/logout`).finally(() => {
            clearAuthStorage();
            window.location.reload();
        });
    }
}

export default authService;
